export const TestIds = {
  link: 'link',
  prev: 'prev',
  next: 'next',
  close: 'close',
  container: 'container',
};
